import React from "react";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../styles";

const useStyles = makeStyles(() => ({
  root: {
    padding: "17px 90px 17px 125px",
    fontFamily: "Archivo, sans-serif",
    fontSize: 14,
  },
  link: {
    color: colors.dark_grey,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  current: {
    color: colors.black,
    fontFamily: 'Archivo-Medium, sans-serif',
    fontWeight: 500,
  },
}));

const CustomBreadcrumb = ({ items }) => {
  const classes = useStyles();

  return (
    <Breadcrumbs separator="/" aria-label="breadcrumb" className={classes.root}>
      {items.map((item, index) =>
        item.path ? (
          <Link
            key={index}
            href={item.path}
            className={classes.link}
            underline="none"
          >
            {item.label}
          </Link>
        ) : (
          <Typography key={index} className={classes.current}>
            {item.label}
          </Typography>
        ),
      )}
    </Breadcrumbs>
  );
};

export default CustomBreadcrumb;
